import { IMainMenuNode } from 'state/unified-menu/types';

/** Depth-first lookup for a section (or any node) id in the main-menu tree. */
export function findMainMenuNodeById(
  nodes: readonly IMainMenuNode[],
  id: string
): IMainMenuNode | undefined {
  if (!id || !nodes.length) {
    return undefined;
  }

  for (const node of nodes) {
    if (node.id === id) {
      return node;
    }
    const nested = findMainMenuNodeById(node.children, id);
    if (nested) {
      return nested;
    }
  }

  return undefined;
}
